module.exports = __webpack_public_path__ + "static/media/TonoDaruma_01C.e893c782.gif";